import { AlertDialogContext, AlertDialogType } from "@contexts/AlertDialogContext"
import { useContext } from "react"

export type AlertUtils = {
    failed: (message: string) => void;
    success: (message: string) => void;
    loading: (message: string) => void;
    hide: () => void;
}

export default function useAlert(): AlertUtils {
    const { show, hide } = useContext(AlertDialogContext)

    return {
        failed: (message: string) => setTimeout(() => show(AlertDialogType.Error, message), 100),
        success: (message: string) => setTimeout(() => show(AlertDialogType.Success, message), 100),
        loading: (message: string) => setTimeout(() => show(AlertDialogType.Loading, message), 100),
        hide
    }
}